import React from 'react';
import { MODULE, VIDEO, AUDIO, MEET, FACE_TO_FACE, MANUAL_EVALUATION, AUTOMATIC_EVALUATION } from 'Constants/General';
import EmptyModules from './Components/EmptyModules';
import Module from './Views/Module';
import LessonVideo from './Views/LessonVideo';
import LessonAudio from './Views/LessonAudio';
import LessonMeet from './Views/LessonMeet';
import LessonFace from './Views/LessonFace';
import LessonEval from './Views/LessonEval';
import LessonAuto from './Views/LessonAuto';

export default function EditCourseLessons({
  module = null,
  deleteModule = () => {},
  updateModule = () => {},
  typeContent,
  addLesson,
  addLessonSession,
  addLessonAutoEvaluation,
  updateLesson,
  updateLessonSessionData,
  currentPositionLesson,
  deleteLesson,
  updateLessonData,
  courseId,
  alert,
  setAlert,
}) {
  if (module === null) {
    return <EmptyModules />;
  }

  if (typeContent === MODULE)
    return (
      <Module
        deleteModule={deleteModule}
        updateModule={updateModule}
        module={module}
        alert={alert}
        setAlert={setAlert}
      />
    );

  if (typeContent === VIDEO)
    return (
      <LessonVideo
        addLesson={addLesson}
        module={module}
        updateLesson={updateLesson}
        currentPositionLesson={currentPositionLesson}
        deleteLesson={deleteLesson}
        updateLessonData={updateLessonData}
        courseId={courseId}
        alert={alert}
        setAlert={setAlert}
      />
    );

  if (typeContent === AUDIO)
    return (
      <LessonAudio
        addLesson={addLesson}
        module={module}
        updateLesson={updateLesson}
        currentPositionLesson={currentPositionLesson}
        deleteLesson={deleteLesson}
        updateLessonData={updateLessonData}
        courseId={courseId}
        alert={alert}
        setAlert={setAlert}
      />
    );

  if (typeContent === MEET)
    return (
      <LessonMeet
        addLessonSession={addLessonSession}
        module={module}
        updateLesson={updateLesson}
        currentPositionLesson={currentPositionLesson}
        deleteLesson={deleteLesson}
        updateLessonSessionData={updateLessonSessionData}
        courseId={courseId}
        alert={alert}
        setAlert={setAlert}
      />
    );

  if (typeContent === FACE_TO_FACE)
    return (
      <LessonFace
        addLessonSession={addLessonSession}
        module={module}
        updateLesson={updateLesson}
        currentPositionLesson={currentPositionLesson}
        deleteLesson={deleteLesson}
        updateLessonSessionData={updateLessonSessionData}
        courseId={courseId}
        alert={alert}
        setAlert={setAlert}
      />
    );

  if (typeContent === MANUAL_EVALUATION)
    return (
      <LessonEval
        addLessonSession={addLessonSession}
        module={module}
        updateLesson={updateLesson}
        currentPositionLesson={currentPositionLesson}
        deleteLesson={deleteLesson}
        updateLessonSessionData={updateLessonSessionData}
        courseId={courseId}
        alert={alert}
        setAlert={setAlert}
      />
    );

  if (typeContent === AUTOMATIC_EVALUATION)
    return (
      <LessonAuto
        addLessonSession={addLessonSession}
        addLessonAutoEvaluation={addLessonAutoEvaluation}
        module={module}
        updateLesson={updateLesson}
        currentPositionLesson={currentPositionLesson}
        deleteLesson={deleteLesson}
        updateLessonSessionData={updateLessonSessionData}
        courseId={courseId}
        alert={alert}
        setAlert={setAlert}
      />
    );
}
